import React from "react";
import AdminUsersPanel, { type AdminUsersInviteEntry } from "@view/panels/workspace/AdminUsers.panel";
import type { AdminUsersViewProps } from "@ps-bridge/contracts/adminUsers";
import type { IOts } from "@ps-bridge/interop";
import type { Ok } from "@ps-bridge/ok";

type AdminUsersPagePanelProps = {
  pageState: "init" | "ready";
  viewProps: AdminUsersViewProps;
  inviteEntries: AdminUsersInviteEntry[];
  onEmailModalSubmit: IOts<Ok>;
  okValue: Ok;
  runIO: (effect: IOts<Ok>) => Ok;
};

const AdminUsersPagePanel: React.FC<AdminUsersPagePanelProps> = ({
  pageState,
  viewProps,
  inviteEntries,
  onEmailModalSubmit,
  okValue,
  runIO,
}) => (
  <div data-testid="page-adminUsers" data-page-state={pageState}>
    <AdminUsersPanel
      viewProps={viewProps}
      inviteEntries={inviteEntries}
      onEmailModalSubmit={onEmailModalSubmit}
      okValue={okValue}
      runIO={runIO}
    />
  </div>
);

export default AdminUsersPagePanel;

